import { Navigate, useLocation } from 'react-router-dom';

/** The old All awards and Stats URLs, now tabs of `/sand-dollars`. The stats sections move from
 *  `?tab=` to `?view=`, since `?tab=` now picks between the two. */
export function SandDollarsRedirect({ tab }: { tab: 'awards' | 'stats' }) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const statsSection = params.get('tab');
  if (tab === 'stats' && statsSection) params.set('view', statsSection);
  params.set('tab', tab);
  return <Navigate to={`/sand-dollars?${params.toString()}`} replace />;
}
